import { ErrorResponse, trackGraphQlError } from './errorUtils';

export const PRICING_BOOK_PAGE_LOAD = 'pricing-book-page-load';
export const PRICING_BENEFITS_PAGE_LOAD = 'pricing-benefits-page-load';
export const PRICING_BOOK_NATIONAL_ENROLL = 'pricing-book-national-enroll';
export const PRICING_BOOK_NATIONAL_UNENROLL = 'pricing-book-national-unenroll';

export const newrelic = {
  addPageAction: (name: string, value: string | object) => {
    if (
      typeof window !== 'undefined' &&
      window.newrelic?.addPageAction instanceof Function
    ) {
      window.newrelic.addPageAction(name, value);
    }
  },
};

export const logNewRelicAction = (
  action: string,
  error?: ErrorResponse,
  additionalData?: Record<string, string | boolean | number>,
) => {
  newrelic.addPageAction(action, {
    ...(error
      ? { ...trackGraphQlError(error), result: 'error' }
      : { result: 'success' }),
    ...additionalData,
  });
};
